import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Brain } from "lucide-react";

const WystepNaSzkolenie = () => (
  <SeoPageLayout title="Występ komediowy" titleAccent="na szkoleniu">
    <SeoSection title="Humor jako narzędzie szkoleniowe">
      <p>Czy wiesz, że ludzie zapamiętują o 40% więcej informacji, gdy towarzyszył im śmiech? Występ komediowy na szkoleniu to nie tylko przerywnik - to strategiczne narzędzie, które wzmacnia przekaz edukacyjny, regeneruje uwagę uczestników i sprawia, że szkolenie zostaje w pamięci na długo.</p>
      <SeoHighlightBox icon={Brain}>
        Badania naukowe potwierdzają: humor zwiększa retencję informacji nawet o 40%. Śmiech to najlepszy sposób na utrwalenie wiedzy.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Jak komik wspiera szkolenie?">
      <SeoStyledList items={[
        "Energetyczne otwarcie - komik przełamuje lody i buduje pozytywną atmosferę",
        "Przerywnik między sesjami - odświeża uwagę i zapobiega znużeniu",
        "Komediowe podsumowanie - humorystyczne streszczenie kluczowych punktów szkolenia",
        "Interaktywne elementy - angażuje uczestników i buduje dynamikę grupy"
      ]} />
    </SeoSection>

    <SeoSection title="Tematyczny humor szkoleniowy">
      <p>Nasz komik może przygotować materiał nawiązujący do tematu szkolenia. Jeśli szkolenie dotyczy sprzedaży - żarty o relacjach z klientami. Szkolenie z zarządzania - humor o hierarchii i komunikacji. Onboarding - zabawne obserwacje o pierwszych dniach w pracy. Treść komediowa wzmacnia przekaz szkoleniowy.</p>
    </SeoSection>

    <SeoSection title="Formaty dla szkoleń">
      <p>Oferujemy elastyczne formaty dopasowane do harmonogramu szkolenia: krótkie 10-minutowe wejścia między blokami, 20-30 minutowe występy jako przerywniki oraz pełne 45-60 minutowe show jako wieczorna atrakcja po dniu szkoleniowym. Każdy format jest dopasowany do wielkości grupy i charakteru szkolenia.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default WystepNaSzkolenie;
